import { defineCustomElement } from "vue";
import ResultItems from "@/components/ResultItems/ResultItems.ce.vue";
import ResultCardSlider from "@/components/ResultCardSlider/ResultCardSlider.ce.vue";
import FilterBar from "@/components/FilterBar/FilterBar.ce.vue";
import SearchApp from "@/components/SearchApp.ce.vue";

const SearchAppComponent = defineCustomElement(SearchApp);
customElements.define("search-app", SearchAppComponent);

const FilterBarComponent = defineCustomElement(FilterBar);
customElements.define("filter-bar", FilterBarComponent);

const ResultItemsComponent = defineCustomElement(ResultItems);
customElements.define("result-items", ResultItemsComponent);

const ResultCardSliderComponent = defineCustomElement(ResultCardSlider);
customElements.define("result-card-slider", ResultCardSliderComponent);
